export default "/assets/webshop/img/stanleystella.jpg?06ddd2b3fec7c22d1cbf5da9991251a9";